import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BASE_URL, PagedResponse } from '@edl-development/edl-common';
import { CustomFormDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-display-dto.model';
import { CustomFormSelectorDTO } from 'src/app/model/observation/custom-forms/custom-form-selector-dto.model';
import { CustomFormUserFormDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-user-form-display-dto.model';
import { CreateObservationDTO } from 'src/app/model/observation/diff/diff-create-dto.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { PaetepApi } from '../../paetep/paetep.api';
import { PagedModel } from 'src/app/model/base/paged.model';

@Injectable()
export class CustomFormsApi extends PaetepApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    GetCustomFormForUserForm(userFormId: string) {
        return this.http.get<CustomFormDisplayDTO>(`${this.baseUri}/observation/customForm/GetCustomFormForUserForm/${userFormId}`, {});
    }

    getPublishedCustomFormsForPortal(paging: PagedModel) {
        const params = this.generatePagingParams(paging);
        
        return this.http.get<PagedResponse<CustomFormSelectorDTO>>(`${this.baseUri}/observation/customForm/GetPublishedCustomFormsForPortal`, { params });
    }

    getPublishedCustomFormsForIndividual(paging: PagedModel) {
        const params = this.generatePagingParams(paging);

        return this.http.get<PagedResponse<CustomFormSelectorDTO>>(`${this.baseUri}/observation/customForm/GetPublishedCustomFormsForIndividual`, { params });
    }

    getUserForm(userFormId: string) {
        return this.http.get<CustomFormUserFormDisplayDTO>(`${this.baseUri}/observation/customForm/userForm/${userFormId}`, {});
    }

    createUserForm(observation: CreateObservationDTO) {
        return this.http.post<ObservationSummaryDTO>(`${this.baseUri}/observation/customForm/userForm/create`, observation);
    }

    saveUserForm(userFormId: string, formAnswers: { [key: string]: string }) {
        return this.http.post<CustomFormUserFormDisplayDTO>(`${this.baseUri}/observation/customForm/userForm/save/${userFormId}`, formAnswers);
    }

    submitUserForm(userFormId: string, formAnswers: { [key: string]: string }) {
        return this.http.post<CustomFormUserFormDisplayDTO>(`${this.baseUri}/observation/customForm/userForm/submit/${userFormId}`, formAnswers);
    }

    signUserForm(userFormId: string, questionId: string) {
        return this.http.post<boolean>(`${this.baseUri}/observation/customForm/userForm/sign/${userFormId}/${questionId}`, {});
    }

    removeSignatureUserForm(userFormId: string, questionId: string) {
        return this.http.post<boolean>(`${this.baseUri}/observation/customForm/userForm/removeSignature/${userFormId}/${questionId}`, {});
    }
}
